// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyC2ZrUWbpyaWQeBXAOZvKVJKVrZqz4lVoE",
//   authDomain: "monarch-annual-reporting-form.firebaseapp.com",
//   projectId: "monarch-annual-reporting-form",
//   storageBucket: "monarch-annual-reporting-form.appspot.com",
//   messagingSenderId: "2007515142",
//   appId: "1:2007515142:web:114b4d3751883049ce0387",
//   measurementId: "G-D0NRLQDDTH"
// };

const firebaseConfig = {
  apiKey: "AIzaSyCAYzWc1G7qf5Tl8KOpwukgxEabEiVR6gc",
  authDomain: "monarch-annual-reporting-32c7d.firebaseapp.com",
  projectId: "monarch-annual-reporting-32c7d",
  storageBucket: "monarch-annual-reporting-32c7d.appspot.com",
  messagingSenderId: "879924451101",
  appId: "1:879924451101:web:34ecea57fe358004ea33f4",
  measurementId: "G-4DKZD7R7CM"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
